// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__13QVt","actionsCol":"EnrolledClinics_actionsCol__2RUNe"};